export default {
	title: "The only leadership organization dedicated to physicians and providers",
	sections: [
		{
			// title: "ARTICLES & Guides",
			// icon: "article",
			items: [
				{ text: "Board of Directors", link: "/about/board" },
				// { text: "Join Our Board", link: "/about/board/apply" },
				{ text: "Leadership", link: "/about/leadership" },
				{ text: "Faculty", link: "/about/faculty" },
				{ text: "Contact Us", link: "/contact" },
			],
		},

		{
			// title: "WELLNESS",
			// icon: "smile",
			items: [
				{ text: "Our Story", link: "/about" },
				{ text: "Partners & Sponsors", link: "/about/partners-and-sponsors" },
				{ text: "Press Room", link: "/about/press-room" },
			],
		},
	],

	// side: {
	// 	title: "AAPL'S PODCAST",
	// 	subTitle: "SoundPractice",
	// 	details: "The business podcast for physicians & health care leaders.",
	// 	buttonText: "Listen Now",
	// },
};
